module.exports = __webpack_public_path__ + "assets/images/pinning2x-ab0720b9b815df5a8d999ee08e92121e.png";